import {deviceTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = deviceTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const deviceReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default deviceReducer;
